import { render, staticRenderFns } from "./AddForeignSchool.vue?vue&type=template&id=933f5dbe&scoped=true"
import script from "./AddForeignSchool.vue?vue&type=script&lang=js"
export * from "./AddForeignSchool.vue?vue&type=script&lang=js"
import style0 from "./AddForeignSchool.vue?vue&type=style&index=0&id=933f5dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933f5dbe",
  null
  
)

export default component.exports